'use client';

import clsx from 'clsx';

import {ErrorForm} from '@/components/error-form';
import {FadeInDownDiv} from '@/components/framer/fade-in-down-div';
import {NotFound as NotFoundIcon} from '@/components/icons/notFound';
import {i18n} from '@/utils/i18n';

export default function Error() {
	return (
		<FadeInDownDiv
			delay={0.3}
			className={clsx(
				'flex',
				'items-center',
				'justify-center',
				'h-full',
				'w-full',
			)}
		>
			<div
				className={clsx(
					'grid',
					'grid-cols-1',
					'lg:grid-cols-2',
					'sm:gap-24',
					'gap-16',
					'sm:mb-24',
					'sm:mt-16',
					'mb-16',
					'mt-8',
				)}
			>
				<title>500 - noe gikk galt | {i18n.main.gjovikregionen}</title>
				<div>
					<h1 className={clsx('text-h1', 'mb-12')}>500</h1>
					<div className={clsx('text-h1', 'mb-3')}>Oooops!</div>
					<div className={clsx('text-h3', 'mb-12')}>
						Noe gikk galt.
					</div>
					<ErrorForm />
				</div>
				<div>
					<NotFoundIcon />
				</div>
			</div>
		</FadeInDownDiv>
	);
}
